<template>
  <v-card
      max-width="600"
      class="mx-auto"
    >
      <v-toolbar
        color="rgb(82, 152, 68)"
        dark
      >
  
        <v-toolbar-title>Available Tenants</v-toolbar-title>
  
        <v-spacer></v-spacer>

      </v-toolbar>
      <div v-if="loading">
        <v-btn round disabled py-6 style="width: 50%;"></v-btn>
        <v-btn block round disabled></v-btn>
        <v-btn block round disabled></v-btn>
        <v-btn block round disabled></v-btn>
      </div>
      <v-list two-line subheader v-if="!loading">
        <v-subheader v-if="authorizedTenants.length > 0">
          <v-icon color="info">mdi-information</v-icon>
          {{userInfo.displayName}}: Choose the tenant you would like to access.
        </v-subheader>
        <v-subheader v-if="authorizedTenants.length == 0">
          <v-icon color="warning">mdi-information</v-icon>
          {{userInfo.displayName}}, your Hatfield account is not authorized to access any Envirodata tenants. Please contact the administrator.
        </v-subheader>
  
        
        <v-list-tile v-for="(item) in authorizedTenants" :key="item.UserId" @click.native="impersonate(item)">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-list-tile-content v-on="on" style="cursor: pointer;">
                <v-list-tile-title>{{ item.TenantName }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.UserName }}</v-list-tile-sub-title>
              </v-list-tile-content>

            </template>
            <span>Click to access tenant {{ item.TenantName }}</span>
          </v-tooltip>
          
            <v-list-tile-action>
                <v-btn icon ripple>
                  <v-icon large color="grey lighten-1">mdi-chevron-right</v-icon>
                </v-btn>
              </v-list-tile-action>
        </v-list-tile>
      

      </v-list>

      <v-dialog v-model="impersonating" persistent max-width="360">
        <v-card>
          <v-card-text class="text-xs-center pt-4 pb-4">
            <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
            <div class="mt-3 title">{{ impersonatingTenant }}</div>
            <div class="mt-1 subheading">The system is impersonating this login. Please wait for completion.</div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const { mapActions } = createNamespacedHelpers('authenticate')

  import * as authService from '../helpers/Office365/azureAuthService'

  export default {
    props: {
      
    },
    data() {
      return {
        azureAccount: null,
        authorizedTenants: [],
        idToken: '',
        loading: true,
        impersonating: false,
        impersonatingTenant: '',
      }
    },
    computed: {
      userInfo() {
        return {
          displayName: this.azureAccount.name,
          email: this.azureAccount.username,
        }
      },
    },
    watch: {
      
    },
    methods: {  
      ...mapActions(['getAvailableTenants', 'impersonateLogIn']),    
      async getTenants() {
        var tenants = await this.getAvailableTenants({email: this.userInfo.email, idToken: this.idToken})
        this.authorizedTenants = tenants
      },
      async impersonate(item) {
        if (this.impersonating) {
          return
        }
        this.impersonating = true
        this.impersonatingTenant = item.TenantName

        try {
          var data = {
            username: item.UserName,
            code: authService.getAzureIdToken(),
          }
          var res = await this.impersonateLogIn(data)
          console.log(res)
          if(res.success) {
            this.$router.push({ name: 'home' })
          }
        } catch (ex) {
          console.error(ex)
        } finally {
          this.impersonating = false
          this.impersonatingTenant = ''
        }
      },
    },
    async mounted() {
      this.loading = true
      var account = authService.getActiveAzureAccount()
      
      if(account == null) {
        this.loading = false
        this.$router.push({ name: 'login' })
      } else {
        this.azureAccount = account
        this.idToken = authService.getAzureIdToken()
        
        try
        {
          await this.getTenants()
          this.loading = false
        }
        catch(ex)
        {
          this.loading = false
          this.$router.push({ name: 'login' })
        }
        
        if(this.authorizedTenants != null && this.authorizedTenants.length == 1) {
          this.impersonate(this.authorizedTenants[0])
        }
      }      
    },
  }
</script>

<style scoped>
  
</style>